import styled from 'styled-components';

export const DivStyled = styled.div`
    padding-left: 20px;
    cursor: pointer;
    &:hover {
        background-color: #F1FAFF;
    };
`